export default __webpack_public_path__ + "media/images/avatars/avatar1-47bfd22204c96aa23843371dfc0e99fb.png";